"use strict";
exports.__esModule = true;
exports.WorkflowName = void 0;
//! New workflow names will require handling in the DequeueMoveTransactionService.ts "updateQueueRecords" method
var WorkflowName;
(function (WorkflowName) {
    WorkflowName["depositRequest"] = "depositRequest";
    WorkflowName["investContribution"] = "investContribution";
    WorkflowName["investmentUpdate"] = "investmentUpdate";
    WorkflowName["newPlan"] = "newPlan";
    WorkflowName["tradeRequest"] = "tradeRequest";
    WorkflowName["bookPushedDeposit"] = "bookPushedDeposit";
    WorkflowName["queueReversalByTracerId"] = "queueReversalByTracerId";
    WorkflowName["queueReversalBySourceTransactionId"] = "queueReversalBySourceTransactionId";
    WorkflowName["queueReversalByOrderId"] = "queueReversalByOrderId";
    WorkflowName["flattenRequest"] = "flattenRequest";
    WorkflowName["queueIndividualSubAccountOrder"] = "queueIndividualSubAccountOrder";
    WorkflowName["distributionRequest"] = "distributionRequest";
    WorkflowName["feeRequest"] = "feeRequest";
    WorkflowName["moveTransactions"] = "moveTransactions";
    WorkflowName["transferSecurity"] = "transferSecurity";
    WorkflowName["planLiquidation"] = "planLiquidation";
    WorkflowName["cashTransferRequest"] = "cashTransferRequest";
    WorkflowName["correctionByAmount"] = "correctionByAmount";
    WorkflowName["advancedCorrection"] = "advancedCorrection";
    WorkflowName["allocateDeposit"] = "allocateDeposit";
    WorkflowName["disbursementRequest"] = "disbursementRequest";
    WorkflowName["cashInterestActivity"] = "cashInterestActivity";
    WorkflowName["fundMerger"] = "fundMerger";
    WorkflowName["externalTransfer"] = "externalTransfer";
    WorkflowName["receiveSecurity"] = "receiveSecurity";
})(WorkflowName = exports.WorkflowName || (exports.WorkflowName = {}));
